package ru.education.building.schedule.widgets

import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.EventNote
import androidx.compose.material.icons.filled.Add
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import androidx.compose.ui.zIndex


@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun CustomAppBar(onTapShowSheet: () -> Unit, onTapShowCalendar: () -> Unit, selectedGroup: String) {

    TopAppBar(
        modifier = Modifier.zIndex(1f),
        title = { Text(selectedGroup) },
        actions = {
            IconButton(
                onClick = { onTapShowSheet() },
                modifier = Modifier
                    //.minimumInteractiveComponentSize()
                    .clip(CircleShape)
            ) {
                Icon(
                    imageVector = Icons.Filled.Add,
                    contentDescription = "Add",
                    modifier = Modifier.size(28.dp)
                )
            }
            IconButton(
                onClick = { onTapShowCalendar() },
                modifier = Modifier
                    //.minimumInteractiveComponentSize()
                    .clip(CircleShape)
            ) {
                Icon(
                    imageVector = Icons.AutoMirrored.Filled.EventNote,
                    contentDescription = "Show",
                    modifier = Modifier.size(28.dp)
                )
            }
            //Spacer(modifier = Modifier.width(5.dp))
        }
    )
}